import React, { FC } from "react";
import ModalContainer from "app/component/modal/ModalContainer";
import CreateOrderModal from "../CreateOrderModal";
import { Button } from "ui/Button";
import { CreateDocumentLayoutProps } from "./types";
import { useTranslation } from "react-i18next";

const CreateDocumentLayout: FC<CreateDocumentLayoutProps> = ({
  hasNext,
  children,
  isOpen,
  isHighestModal,
  saveHandler,
  closeHandler,
  title,
  isShowDailyRenew,
  closeDailyRenew,
  editId,
  isAdvance
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <>
      <ModalContainer
        onEnter={hasNext ? saveHandler : undefined}
        isOpen={isOpen}
        destroy={true}
        highestModal={isHighestModal}
        overlayClick={closeHandler}
      >
        <div className="box-modal">
          <div className="box-modal_close" onClick={closeHandler}></div>
          <div className="box-modal-title">{title}</div>
          <div className="box-modal-content">{children}</div>
          <div className="box-modal-footer">
            <Button
              onClick={closeHandler}
              buttonWidth="153px"
              buttonText={t("modals.create_advance_report_modal.cancel")}
            />
            <Button
              onClick={saveHandler}
              buttonWidth="153px"
              buttonColor="green"
              buttonText={
                hasNext
                  ? t("request_detail.request_button_controls.next")
                  : t("modals.create_advance_report_modal.complete")
              }
            />
          </div>
        </div>
      </ModalContainer>
      <CreateOrderModal
        id={editId!}
        isOpen={isShowDailyRenew}
        isAdvance={isAdvance}
        onClose={closeDailyRenew}
        dailyRenew={true}
      />
    </>
  );
};

export default CreateDocumentLayout;
